import { createSignal } from "solid-js";

export default function createUpdate() {
  const [updateRef, setUpdateRef] = createSignal(Symbol("update"));

  return Object.assign(
    () => {
      setUpdateRef(Symbol("update"));
    },
    {
      listen() {
        updateRef();
      },
    },
  );
}
